import { viewport } from '../../utils/viewport';

class LogosBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.container = block.querySelector('.logos__container');
    this.rows = block.querySelectorAll('.logos__row');
    this.items = block.querySelectorAll('.logos__item');

    if (this.block.classList.contains('logos--carousel')) {
      this.init();
    }
  }

  init() {
    this.rows.forEach((row) => {
      viewport.observe(row, (el) => el.classList.add('logos__row--visible'));
    });

    setTimeout(() => {
      this.rows.forEach((row) => {
        const group = row.querySelector('.logos__row-group');

        if (group) {
          row.appendChild(group);
        }
      });
    }, 15000);

    window.addEventListener('blur', () => this.pause());
    window.addEventListener('focus', () => this.resume());
  }

  pause() {
    this.block.classList.add('logos--paused');
  }

  resume() {
    this.block.classList.remove('logos--paused');
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.logos').forEach((block) => {
  new LogosBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=logos', ($block, attributes) => {
    new LogosBlock($block.find('.logos').get(0), attributes);
  });
}